import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteWithToken, getLocalStorage, getWithToken, patchWithToken, postWithToken } from '../API/Api';
import Loader from '../components/Loader';
import STAR_ICON from '../assets/icons/ComniqaiIcon-V3.0/star-icon.svg';
import MULTISTAR_ICON from '../assets/icons/ComniqaiIcon-V3.0/star-icon1.svg';
import BOTPROFILE_ICON from '../assets/icons/ComniqaiIcon-V3.0/bot-activeicon.svg';
import BOTPROFILE_PINKICON from '../assets/icons/ComniqaiIcon-V3.0/bot-pinkicon.svg';
import GREETING_ICON from '../assets/icons/ComniqaiIcon-V3.0/greeting-icon.svg';
import { IoClose } from 'react-icons/io5';
import SAVE_ICON from '../assets/icons/ComniqaiIcon-V3.0/save-icon.svg';
import SubContext from '../contexts/SubContext';

const ValidationErrors = {
  empty: {
    bot_name: 'Name required',
    tone: 'Tone required',
  },
};

const TONES = [
  { name: 'Funny' },
  { name: 'Humorous' },
  { name: 'Sales Genius' },
  { name: 'Empathetic' },
  { name: 'Calm' },
  { name: 'Friendly' },
  { name: 'Helpful' },
  { name: 'Mindful' },
  { name: 'Spiritual' },
  { name: 'Comedian' },
];

const ROLES = [{ name: 'Virtual Assistant' }, { name: 'Business Owner' }, { name: 'Sales representative' }, { name: 'Marketing specialist' }, { name: 'Financial manager' }];

const countCharacters = (text) => {
  if (text) {
    return text.length;
  }
  return 0;
};
const maxLength = 5000;

const KnowledgeBaseSetMessage = () => {
  const [values, setValues] = useState({
    bot_name: '',
    tone: '',
    role: '',
    welcome_msg: '',
    agent_rules: '',
    phone_number: '',
    name: '',
    email_address: '',
    call_to_actions: '',
  });
  const [loader, setLoader] = useState(false);
  const [blurPopup, setBlurPopup] = useState(false);
  const [botId, setBotId] = useState('');
  const [apiTokenData, setApiTokenData] = useState('');
  const [childData, setChildData] = useState(false);
  const Navigate = useNavigate();
  const { state } = useLocation();
  const subsFlag = useContext(SubContext);
  const { bot_name, tone, role, welcome_msg, agent_rules } = values;
  const [bgPopup, setBgPopup] = useState(false);
  const [editLeadPopup, setEditLeadPopup] = useState(false);
  const [editLeadClosingPopup, setEditLeadClosingPopup] = useState(false);
  const [informationValues, setInformationValues] = useState({
    id: '',
    welcome_lead_message: '',
    lead_status: false,
    positive_lead_choice: '',
    continue_lead_choice: '',
    closing_lead_message: '',
    positive_lead_closing_choice: '',
    continue_lead_closing_choice: '',
    generate_lead_choice: '',
    create_lead_choice: '',
    lead_form: false,
    is_calendar: false,
  });
  const [questions, setQuestions] = useState([{ id: 1, question: '', lead_info_status: false, isQuestionEditable: false }]);
  const [recommendationAnswers, setRecommendationAnswers] = useState([{ id: 1, parentId: null, question: '' }]);

  const {
    welcome_lead_message,
    positive_lead_choice,
    continue_lead_choice,
    closing_lead_message,
    positive_lead_closing_choice,
    continue_lead_closing_choice,
    generate_lead_choice,
    create_lead_choice,
  } = informationValues;

  const [errors, setErrors] = useState({
    bot_name: '',
    tone: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (value.length >= maxLength) {
      toast.dismiss();
      toast.info('Character limit exceeded! Please keep it under 5000 characters.');
    }

    setValues({ ...values, [name]: value || null });
    setErrors({ ...errors, [name]: null });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
      getBotMessageDetails(JSON.parse(token));
      getInformationValues(JSON.parse(token));
    } else {
      Navigate('/login');
    }
  }, [childData]);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
    }
  }, []);

  useEffect(() => {
    if (editLeadPopup || editLeadClosingPopup) {
      document.body.classList.add('popup-open');
    } else {
      document.body.classList.remove('popup-open');
    }
  }, [editLeadPopup, editLeadClosingPopup]);

  const getBotMessageDetails = (token) => {
    setLoader(true);
    getWithToken('company_base/', token)
      .then((response) => {
        if (response.status === 201) {
          setBotId(response?.data?.id);
          setValues({
            ...values,
            bot_name: response?.data?.bot_name,
            tone: response?.data?.tone,
            role: response?.data?.role,
            welcome_msg: response?.data?.welcome_msg || null,
            agent_rules: response?.data?.agent_rules || null,
            email_address: response?.data?.email_address,
            name: response?.data?.name,
            phone_number: response?.data?.phone_number,
            call_to_actions: response?.data?.call_to_actions,
          });
          setChildData(false);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
        // toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleSubmit = async (valueName) => {
    const tempErrors = { ...errors };
    Object.keys(values).forEach((key) => {
      if (!values[key]) {
        tempErrors[key] = ValidationErrors.empty[key];
      }
    });

    setErrors(tempErrors);

    if (Object.values(tempErrors).filter((obj) => !!obj).length > 0) {
      return false;
    }

    const payload = {
      bot_name,
      tone,
      role,
      welcome_msg,
      agent_rules,
    };
    try {
      const response = await patchWithToken(`company_base/${botId}/`, apiTokenData, payload);
      if (response.status === 200) {
        toast.dismiss();
        toast.success(response.message);
        getBotMessageDetails(apiTokenData);
        subsFlag.setUpdateValue('1');
      } else if (response.status === 400) {
        toast.error(response.message);
      } else {
        toast.error('Please create the company.');
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleBgDelete = async () => {
    try {
      const response = await deleteWithToken('Widget_bg_ColorAPI/', apiTokenData);
      if (response.status === 200) {
        setBgPopup(false);
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getInformationValues = async (token) => {
    try {
      const response = await getWithToken('LeadsAPI', token);

      if (response.status === 200) {
        const leadInformationQuestions =
          response?.data?.lead_information?.map((question) => ({
            id: question.id,
            question: question.question,
            lead_info_status: question.lead_info_status,
            isQuestionEditable: question.isQuestionEditable,
            filedName: question.filedName,
            answer: question.answer,
          })) || [];

        const recommendationAnswer = leadInformationQuestions.map((answer) => answer.answer).flat();

        setRecommendationAnswers(recommendationAnswer || []);
        setQuestions(leadInformationQuestions);

        subsFlag.setUpdateValue('1');

        setInformationValues({
          id: response?.data?.id || '',
          welcome_lead_message: response?.data?.welcome_lead_message || '',
          lead_status: response?.data?.lead_status || '',
          positive_lead_choice: response?.data?.positive_lead_choice || '',
          continue_lead_choice: response?.data?.continue_lead_choice || '',
          closing_lead_message: response?.data?.closing_lead_message || '',
          positive_lead_closing_choice: response?.data?.positive_lead_closing_choice || '',
          continue_lead_closing_choice: response?.data?.continue_lead_closing_choice || '',
          generate_lead_choice: response?.data?.generate_lead_choice || '',
          create_lead_choice: response?.data?.create_lead_choice || '',
          lead_form: response?.data?.lead_form || '',
          is_calendar: response?.data?.is_calendar || '',
        });
      } else {
        toast.error('Unexpected response code: ' + response.status);
      }
    } catch (error) {
      console.error('Error fetching information values:', error);
      // toast.error('An error occurred while fetching data.');
    }
  };

  const informationHandleChange = ({ target: { name, checked, value } }) => {
    let updatedValues = { ...informationValues };
    if (name === 'lead_form') {
      updatedValues = { ...updatedValues, lead_form: checked, is_calendar: !checked };
    } else if (name === 'is_calendar') {
      updatedValues = { ...updatedValues, lead_form: !checked, is_calendar: checked };
    } else {
      updatedValues[name] = name === 'lead_status' ? checked : value || null;
    }
    setInformationValues(updatedValues);

    if (['lead_status', 'lead_form', 'is_calendar'].includes(name)) {
      handleInfoSubmit(updatedValues, name);
    }
  };

  const handleInfoSubmit = (formData, key) => {
    setLoader(true);

    let body;

    if (key === 'lead_form' || key === 'is_calendar') {
      body = { lead_form: formData.lead_form || false, is_calendar: formData.is_calendar || false };
    } else {
      body = key ? { [key]: formData[key] || false, ...(key === 'lead_status' && { welcome_lead_message }) } : formData;
    }

    const apiCall = informationValues.id ? patchWithToken : postWithToken;

    apiCall('LeadsAPI', apiTokenData, body)
      .then((response) => {
        setLoader(false);
        if (response.status === 200) {
          getInformationValues(apiTokenData);
          toast.dismiss();
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error('API error:', error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handlePopupContentClick = (event) => {
    event.stopPropagation();
  };

  const handleEnhancedAi = (agent_rules) => {
    setLoader(true);

    if (!agent_rules?.trim()) {
      toast.error('System Prompt cannot be blank');
      setLoader(false);
      return;
    }

    postWithToken('enhance_prompt', apiTokenData, { prompt: agent_rules })
      .then((response) => {
        if (response.status === 200) {
          let trimmedResponse = response.data;
          if (trimmedResponse.length > 5000) {
            trimmedResponse = trimmedResponse.substring(0, 5000);
          }
          getInformationValues(apiTokenData);
          const updatedValues = {
            ...values,
            agent_rules: trimmedResponse,
          };
          setValues(updatedValues);
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
        toast.error('An error occurred while processing your request.');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <>
      <div className='comniq-container'>
        <div className='comniq-container-box mb-4'>
          <div className='d-flex align-items-center gap-3'>
            <div className='comniq-icon-box d-flex align-items-center justify-content-center'>
              <img src={BOTPROFILE_ICON} alt='comniqai-logo' className='img-fluid' />
            </div>
            <div>
              <h5 className='mb-1 outfit-bold'>Bot Profile</h5>
              <p className='text-muted mb-0 outfit-regular'>Configure your AI assistant's personality and behavior</p>
            </div>
          </div>
        </div>

        <div className='knowledge-hub'>
          <div className='card-body'>
            <div class='mb-4'>
              <div class='d-flex align-items-center gap-3'>
                <div
                  class='d-flex align-items-center justify-content-center'
                  style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'rgba(220, 83, 133, 0.1)' }}
                >
                  <img src={BOTPROFILE_PINKICON} alt='comniaqi-logo' className='img-fluid' />
                </div>
                <div>
                  <h5 class='outfit-bold mb-1'>Bot Personality</h5>
                  <p class='text-muted mb-0 outfit-regular'>Define how your AI assistant communicates</p>
                </div>
              </div>
            </div>
            <form onSubmit={onFormSubmit} className='chatbox-field'>
              <div className='comniq-box-shadow'>
                <div className='chatbox-input-text input-GPT new'>
                  <label className='outfit-medium'>Bot Name*</label>
                  <div className='chatbox-input-field position-relative'>
                    <img src={BOTPROFILE_PINKICON} alt='bot-icon' className='input-img' />
                    <input
                      type='text'
                      placeholder='John'
                      className='form-control chatbox-input box-shadow-hover outfit-regular ps-5'
                      id='bot_name'
                      name='bot_name'
                      value={bot_name}
                      autoComplete='off'
                      onChange={handleChange}
                    />
                    <div className='chat-error'>{errors.bot_name && <p className='text-danger insta-smart-error'>{errors.bot_name}</p>}</div>
                  </div>
                </div>
              </div>

              <div className='comniq-box-shadow'>
                <div className='chatbox-input-text input-GPT new'>
                  <label className='outfit-medium d-flex align-items-center gap-2'>
                    <img src={GREETING_ICON} alt='greeting-icon' />
                    Initial Greeting
                  </label>
                  <div className='chatbox-input-field'>
                    <textarea
                      rows='6'
                      className='form-control chatbox-input h-25 box-shadow-hover outfit-regular'
                      placeholder='Message'
                      id='welcome_msg'
                      name='welcome_msg'
                      value={welcome_msg}
                      autoComplete='off'
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className='row gy-3 comniq-box-shadow mx-0'>
                <div className='col-12 col-md-6 ps-md-0 m-0'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Bot Tone*</label>
                    <div className='chatbox-input-field'>
                      <select className='form-control box-shadow-hover outfit-regular' name='tone' value={tone} onChange={handleChange}>
                        <option selected hidden>
                          Choose the Tone
                        </option>
                        {TONES.map((row, i) => (
                          <option key={i}>{row?.name}</option>
                        ))}
                      </select>
                      <div className='chat-error'>{errors.tone && <p className='text-danger insta-smart-error'>{errors.tone}</p>}</div>
                    </div>
                  </div>
                </div>
                <div className='col-12 col-md-6 pe-md-0 m-0'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Bot Role</label>
                    <div className='chatbox-input-field'>
                      <select className='form-control box-shadow-hover outfit-regular' name='role' value={role} onChange={handleChange}>
                        <option selected hidden>
                          Choose the Role
                        </option>
                        {ROLES.map((row, i) => (
                          <option key={i}>{row?.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='comniq-box-shadow'>
                <div className='chatbox-input-text input-GPT new'>
                  <div className='d-flex align-items-center flex-wrap mb-2 gap-2'>
                    <div
                      class='d-flex align-items-center justify-content-center'
                      style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'rgba(220, 83, 133, 0.1)' }}
                    >
                      <img src={MULTISTAR_ICON} alt='comniqai-logo' className='img-fluid' />
                    </div>
                    <label className='outfit-medium'>Bot Rules & Guidelines</label>
                  </div>
                  <small class='text-muted d-block mb-2 outfit-medium'>
                    Define the rules and guidelines that your AI assistant will follow during conversations. These instructions help shape how your bot responds and what
                    information it can or cannot share.
                  </small>
                  <div className='chatbox-input-field'>
                    <textarea
                      rows='6'
                      className='form-control chatbox-input h-25 box-shadow-hover outfit-regular'
                      placeholder='Agent Rules'
                      id='agent_rules'
                      name='agent_rules'
                      value={agent_rules}
                      autoComplete='off'
                      onChange={handleChange}
                      maxLength={5000}
                    ></textarea>
                  </div>
                  <div className='d-flex align-items-center justify-content-between mt-2'>
                    <p className='mb-0 outfit-regular font14 color-theme-slateGray'>({countCharacters(agent_rules) || 0} / 5000)</p>
                    <div className='enhanced-content'>
                      <button className='btn btn-enhanced-ai outfit-regular gap-2' onClick={() => handleEnhancedAi(agent_rules)}>
                        <img src={STAR_ICON} alt='star-icon' className='star-icon' />
                        Enhance AI
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-wrap align-items-center justify-content-between'>
                <button type='submit' className='chatbot-save-btn d-flex align-items-center gap-2' id='firstButton' onClick={handleSubmit}>
                  <img src={SAVE_ICON} alt='save-icon' /> Save Changes
                </button>
                {subsFlag?.subscriptionFlag?.user?.subscription?.name !== 'Pro' && state != null && state?.faqFlag && (
                  <button
                    className='btn btn-submit-login bg-themeLightGreenGradient'
                    onClick={() => Navigate('/chatbot/customizewidget', { state: { faqFlag: true, id: state?.id, length: state?.length } })}
                  >
                    Continue
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      {loader && (
        <div className='loader-center'>
          <Loader />
        </div>
      )}
      {blurPopup && (
        <div className='custom-popup'>
          <div className='popup-content'>
            <div className={'popup-head text-center'}>
              <h4>Train Agent Again</h4>
            </div>
            <hr />
            <div className='popup-footer text-center'>
              <button
                className='btn danger-btn mx-1 text-capitalize'
                data-dismiss='modal'
                onClick={() => {
                  setBlurPopup(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {bgPopup && (
        <div className='custom-popup'>
          <div className='popup-content'>
            <h4 className='outfit-bold'>Are you sure you want to delete?</h4>
            <hr />
            <div className={'popup-head'}>
              <p className='outfit-regular'> </p>
            </div>
            <hr />
            <div className='popup-footer'>
              <button className='btn bg-danger text-white mx-1 text-capitalize' onClick={() => handleBgDelete()}>
                Delete
              </button>
              <button className='btn danger-btn mx-1 text-capitalize' data-dismiss='modal' onClick={() => setBgPopup(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {editLeadPopup && (
        <div className='custom-popup' onClick={() => setEditLeadPopup(false)}>
          <div className='popup-content position-relative' onClick={handlePopupContentClick}>
            <span className='lead-close-icon' onClick={() => setEditLeadPopup(false)}>
              <IoClose />
            </span>
            <div className={'popup-head chatbox-field'}>
              <div className='chatbox-input-text input-GPT new mb-5'>
                <label className='outfit-medium text-white'>Positive Lead Choice</label>
                <div className='chatbox-input-field w-100'>
                  <input
                    type='text'
                    placeholder='Lead choice'
                    className='form-control chatbox-input'
                    name='positive_lead_choice'
                    value={positive_lead_choice}
                    maxLength={30}
                    autoComplete='off'
                    onChange={informationHandleChange}
                  />
                </div>
              </div>
              <div className='chatbox-input-text input-GPT new mb-5'>
                <label className='outfit-medium text-white'>Continue Lead Choice</label>
                <div className='chatbox-input-field  w-100'>
                  <input
                    type='text'
                    placeholder='Lead choice'
                    className='form-control chatbox-input'
                    name='continue_lead_choice'
                    value={continue_lead_choice}
                    maxLength={30}
                    autoComplete='off'
                    onChange={informationHandleChange}
                  />
                </div>
              </div>
            </div>
            <div className='popup-footer'>
              <button className='btn bg-primary mx-1 text-white' onClick={() => setEditLeadPopup(false)}>
                Save
              </button>
              {/* <button className='btn danger-btn mx-1 text-capitalize' data-dismiss='modal' onClick={() => setEditPopup(false)}>
                Cancel
              </button> */}
            </div>
          </div>
        </div>
      )}
      {editLeadClosingPopup && (
        <div className='custom-popup' onClick={() => setEditLeadClosingPopup(false)}>
          <div className='popup-content position-relative' onClick={handlePopupContentClick}>
            <span className='lead-close-icon' onClick={() => setEditLeadClosingPopup(false)}>
              <IoClose />
            </span>
            <div className={'popup-head chatbox-field'}>
              <div className='chatbox-input-text input-GPT new mb-5'>
                <label className='outfit-medium text-white'>Lead Closing Choice</label>
                <div className='chatbox-input-field w-100'>
                  <input
                    type='text'
                    placeholder='Lead choice'
                    className='form-control chatbox-input'
                    name='positive_lead_closing_choice'
                    value={positive_lead_closing_choice}
                    maxLength={30}
                    autoComplete='off'
                    onChange={informationHandleChange}
                  />
                </div>
              </div>
              <div className='chatbox-input-text input-GPT new mb-5'>
                <label className='outfit-medium text-white'>Continue Chat Choice</label>
                <div className='chatbox-input-field  w-100'>
                  <input
                    type='text'
                    placeholder='Lead choice'
                    className='form-control chatbox-input'
                    name='continue_lead_closing_choice'
                    value={continue_lead_closing_choice}
                    maxLength={30}
                    autoComplete='off'
                    onChange={informationHandleChange}
                  />
                </div>
              </div>
              <div className='chatbox-input-text input-GPT new mb-5'>
                <label className='outfit-medium text-white'>Generate Chat Choice</label>
                <div className='chatbox-input-field  w-100'>
                  <input
                    type='text'
                    placeholder='Lead choice'
                    className='form-control chatbox-input'
                    name='generate_lead_choice'
                    value={generate_lead_choice}
                    maxLength={30}
                    autoComplete='off'
                    onChange={informationHandleChange}
                  />
                </div>
              </div>
            </div>
            <div className='popup-footer'>
              <button className='btn bg-primary mx-1 text-white' onClick={() => setEditLeadClosingPopup(false)}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default KnowledgeBaseSetMessage;
